module.exports = __webpack_public_path__ + "static/media/search.69d77f40.svg";